import { useQuery } from '@tanstack/react-query';

import { globalState, program } from '@/constants/solana';
import { compareData } from '@/utils/fetch.utils';

export const fetchGlobalState = async () => {
  if (!globalState) return null;
  return await program.account.globalState.fetch(globalState);
};

export const useFetchGlobalState = () => {
  return useQuery({
    queryKey: ['global-state'],
    refetchInterval: 2 * 60 * 1000,
    structuralSharing: compareData,
    queryFn: async () => {
      return await fetchGlobalState();
    },
  });
};
